import PropTypes from 'prop-types';
import clsx from 'clsx';

// Components
import { HalfBarChartComponent } from '../HalfBarChart';
import ChartWrapper from '../ChartWrapper';
import SingleOuterPieChart from '../SingleOuterPieChart';

const AgeGenderChart = ({
    data,
    className = '',
    onReset = () => {
        /** */
    },
    isLoading = false,
    setRequestParams,
    setState,
    ...restProps
}) => {
    return (
        <ChartWrapper
            className={clsx(className, {
                'flex-wrap justify-center gap-y-8 !space-y-0 lg:gap-x-20': !restProps?.isExport,
                'items-center justify-between': restProps?.isExport
            })}
            isLoading={isLoading}
            onReset={onReset}
            data={data}
            activeFilterBase={data.defaultFilter ?? 'global'}
            // Changing filters should generate an error while there are no real data coming from the API
            setRequestParams={setRequestParams}
            setState={setState}
            legendType="square"
            {...restProps}>
            <HalfBarChartComponent
                className={clsx({
                    '!h-auto min-w-[190px] flex-1 !overflow-visible': !restProps?.isExport
                })}
            />
            <SingleOuterPieChart />
        </ChartWrapper>
    );
};

AgeGenderChart.propTypes = {
    data: PropTypes.object,
    className: PropTypes.string,
    onReset: PropTypes.func,
    isLoading: PropTypes.bool
};

export default AgeGenderChart;
